import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "audience-manager__empty-text" };
import { computed, onMounted, onBeforeUnmount } from 'vue';
import router from '@/router';
import store from '@/store';
import AudienceHeader from '@/features/AudienceManager/components/AudienceHeader.vue';
import AudienceManagerFooter from '@/features/AudienceManager/components/AudienceFooter/AudienceFooter.vue';
import AudienceCompositionStage from '@/features/AudienceManager/components/Stages/Composition/AudienceCompositionStage.vue';
import AudienceIntegrationStage from '@/features/AudienceManager/components/Stages/Integrations/AudienceIntegrationStage.vue';
import AudienceHistoricStage from '@/features/AudienceManager/components/Stages/Historic/AudienceHistoricStage.vue';
import ModalExportationAudience from '@/features/AudienceManager/components/Modals/ExportationAudience/ModalExportationAudience.vue';
import ModalStartTimeError from '@/features/AudienceManager/components/Modals/ModalStartTimeError.vue';
import LoadSpinner from '@/components/_atoms/LoadSpinner.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceManager',
    setup(__props) {
        const compositionGroups = [{ isInclude: true }, { isInclude: false }];
        const activateExportationAudienceModal = computed(() => store.getters['audienceManager/activateExportationAudienceModal']);
        const isLoadingPage = computed(() => store.getters['audienceManager/getLoadingPage']);
        const hasNoAudienceData = computed(() => store.getters['audienceManager/hasNoAudienceData']);
        const isViewMode = computed(() => store.getters['audienceManager/isView']);
        const fetchCriteriaOptions = (mode) => {
            store.dispatch('audienceManager/fetchCriteriaOptions', mode);
        };
        const setAudienceID = () => {
            const audienceID = router.currentRoute.value.params.id;
            store.dispatch('audienceManager/setAudienceID', audienceID);
        };
        const changeStep = (step) => {
            store.dispatch('audienceManager/changeStep', step);
        };
        const resetAudienceState = () => {
            store.dispatch('audienceManager/resetBaseState');
            store.dispatch('audienceManager/resetCompositionState');
        };
        const initializeAudienceManager = () => {
            setAudienceID();
            const isCreatingAudience = router.currentRoute.value.fullPath.includes('/create');
            fetchCriteriaOptions(isCreatingAudience ? 'create' : 'view');
        };
        onMounted(() => {
            initializeAudienceManager();
        });
        onBeforeUnmount(() => {
            resetAudienceState();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AudienceHeader, null, {
                    "step-1": _withCtx(() => [
                        (hasNoAudienceData.value && isViewMode.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('audiences.empty-audience.empty-query')), 1),
                                _createElementVNode("button", {
                                    class: "btn audience-manager__btn",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (changeStep(2)))
                                }, _toDisplayString(_ctx.$t('audiences.empty-audience.see-integrations')), 1)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(compositionGroups, (typeGroup, index) => {
                                return _createVNode(AudienceCompositionStage, {
                                    key: index,
                                    "is-include": typeGroup.isInclude
                                }, null, 8, ["is-include"]);
                            }), 64))
                    ]),
                    "step-2": _withCtx(() => [
                        _createVNode(AudienceIntegrationStage)
                    ]),
                    "step-3": _withCtx(() => [
                        _createVNode(AudienceHistoricStage)
                    ]),
                    _: 1
                }),
                _createVNode(AudienceManagerFooter),
                (activateExportationAudienceModal.value)
                    ? (_openBlock(), _createBlock(ModalExportationAudience, { key: 0 }))
                    : _createCommentVNode("", true),
                _createVNode(ModalStartTimeError),
                _createVNode(LoadSpinner, {
                    loading: isLoadingPage.value,
                    id: "audiences-manager",
                    color: "purple"
                }, null, 8, ["loading"])
            ], 64));
        };
    }
});
